var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_vm._l(_vm.form.images, function (image) {
    return _c('v-flex', {
      key: image.id,
      staticClass: "image-preview",
      staticStyle: {
        "overflow": "hidden"
      },
      attrs: {
        "md4": ""
      }
    }, [_c('div', {
      staticClass: "image-wrapper",
      class: {
        default: image.id === _vm.form.default_image_id
      },
      on: {
        "click": function click($event) {
          return _vm.setDefaultImage(image.id);
        }
      }
    }, [_c('v-img', {
      attrs: {
        "cover": "",
        "max-height": "132",
        "src": image.url
      }
    }), image.id === _vm.form.default_image_id ? _c('div', {
      staticClass: "hint-wrapper blur-box"
    }, [_c('v-tooltip', {
      attrs: {
        "top": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function fn(_ref) {
          var on = _ref.on;
          return [_c('v-icon', _vm._g({
            attrs: {
              "color": "rgba(255,255,255,0.8)"
            }
          }, on), [_vm._v(" mdi-information-outline ")])];
        }
      }], null, true)
    }, [_vm._v(" " + _vm._s(_vm.$t('modules.crowdfunding.selectedAsDef')) + " ")])], 1) : _vm._e(), _c('div', {
      staticClass: "delete-action blur-box"
    }, [_c('IconCustom', {
      attrs: {
        "name": "icn24_trash_can",
        "color": "rgba(255,255,255,0.8)"
      },
      nativeOn: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.removeImage(image.uuid, image.id === _vm.form.default_image_id);
        }
      }
    })], 1)], 1)]);
  }), !_vm.form.images.length ? _c('v-flex', {
    attrs: {
      "md4": ""
    }
  }) : _vm._e(), _c('v-flex', {
    attrs: {
      "md4": "",
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "load-image-wrapper"
  }, [_vm.loading ? _c('v-progress-circular', {
    attrs: {
      "color": "primary",
      "indeterminate": ""
    }
  }) : _vm._e(), !_vm.loading ? _c('div', {
    staticClass: "image",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.$refs.image.click();
      }
    }
  }, [_c('div', {
    staticClass: "pt-5 pb-7"
  }, [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v(" mdi-cloud-upload ")]), _c('p', [_vm._v(" " + _vm._s(_vm.$t('modules.crowdfunding.uploadImage')) + " ")]), _c('p', [_vm._v("PNG / JPG")])], 1), _c('input', {
    ref: "image",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "input": _vm.setImage
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "text-center mt-2"
  })], 1)])], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }